import Model from './Model'

export default class PageComment extends Model {
  static entity = 'page_comment'

  static fields () {
    return {
      id: this.attr(null),
      account_id: this.attr(''),
      page_id: this.attr(''),
      user_id: this.attr(''),
      body: this.attr(''),
      mentions: this.attr(''),
      internal: this.attr(false),
      created_at: this.attr(''),
      edited_at: this.attr(null),
      by_user_id: this.attr(null)
    }
  }
}
